/* MONTAGE · Botschafter mit Film
   Der Film lädt vor, sobald jemand den Knopf berührt oder ansteuert, und
   läuft beim Klick sofort an. Bis das erste Bild kommt, steht ein
   Ladekreis. Blockt der Browser den Ton (etwa iOS im Stromsparmodus),
   läuft der Film stumm an statt gar nicht. Schließen, Ende und Escape
   bringen den Text zurück. */
(function () {
  function starte(wurzel) {
    var film = wurzel.querySelector('.mt-botschafter__film');
    var auf = wurzel.querySelector('[data-film-auf]');
    var zu = wurzel.querySelector('[data-film-zu]');
    if (!film || !auf) return;

    var vorgeladen = false;
    function vorladen() {
      if (vorgeladen) return;
      vorgeladen = true;
      film.preload = 'auto';
      if (film.readyState < 2) film.load();
    }
    auf.addEventListener('pointerenter', vorladen);
    auf.addEventListener('touchstart', vorladen, { passive: true });
    auf.addEventListener('focus', vorladen);

    function laeuft() {
      wurzel.classList.remove('ist-laedt');
    }
    function laedt() {
      if (wurzel.classList.contains('ist-offen')) wurzel.classList.add('ist-laedt');
    }
    film.addEventListener('playing', laeuft);
    film.addEventListener('waiting', laedt);

    function abspielen() {
      var p = film.play();
      if (p && p.catch) {
        p.catch(function (e) {
          if (e && e.name === 'NotAllowedError') {
            film.muted = true;
            film.play().catch(function () { laeuft(); });
          }
        });
      }
    }

    function oeffne() {
      vorgeladen = true;
      film.preload = 'auto';
      wurzel.classList.add('ist-offen');
      if (film.readyState < 3) wurzel.classList.add('ist-laedt');
      film.setAttribute('controls', '');
      film.removeAttribute('tabindex');
      abspielen();
      if (zu) zu.focus({ preventScroll: true });
      // Mobil schrumpft die Bühne auf 16:9, also danach mittig holen.
      // Erst im nächsten Bild messen, sonst zählt noch die alte Höhe.
      if (window.matchMedia('(max-width: 989px)').matches) {
        requestAnimationFrame(function () {
          var r = wurzel.querySelector('.mt-botschafter__buehne').getBoundingClientRect();
          window.scrollTo({
            top: window.scrollY + r.top - Math.max(0, (window.innerHeight - r.height) / 2),
            behavior: 'smooth'
          });
        });
      }
    }
    function schliesse() {
      film.pause();
      film.removeAttribute('controls');
      film.setAttribute('tabindex', '-1');
      wurzel.classList.remove('ist-offen', 'ist-laedt');
      auf.focus({ preventScroll: true });
    }

    auf.addEventListener('click', oeffne);
    if (zu) zu.addEventListener('click', schliesse);
    film.addEventListener('ended', schliesse);
    wurzel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wurzel.classList.contains('ist-offen')) schliesse();
    });
  }

  function alle() {
    document.querySelectorAll('[data-mt-botschafter]').forEach(function (w) {
      if (w.dataset.bereit) return;
      w.dataset.bereit = '1';
      starte(w);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
